import {combineEpics} from 'redux-observable';
import channelsEpic from './channelsEpic';

export default combineEpics(channelsEpic);
